export default __webpack_public_path__ + "static/media/scout-cellar.0bd8f290.png";